<template>
  <section class="pb-6 lg:pb-12">
    <Heading :text="title" :size="1" class="text-center" />
  </section>
</template>
<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>
